<template>


  <div class="content-wrap">
    <div class="search-wrap">
      <div class="row">
        <div class="col-md-2 mb-3">
          <label for="" class="form-label">회계년도</label>
          <div class="d-flex justify-content-between">
            <DatePicker v-model="state.searchParams.fs_year" :format="state.format" :year-picker="true" />
          </div>
        </div>
        <div class="col-md-2 mb-3">
            <ElLabel name="이벤트 이름">
              <template #end="{id}">
                <div class="d-flex justify-content-between">
                  <ElInput :id="id" classNm="form-control me-1" v-model="state.searchParams.event_nm" @inputKeyupEnter="searchEvent"/>
                </div>
              </template>
            </ElLabel>


        </div>
        <div class="col-md-2 mb-3">
          <ElLabel name="목적">
              <template #end="{id}">
                <div class="d-flex justify-content-between">
                  <ElInput :id="id" classNm="form-control me-1" v-model="state.searchParams.prpss"  @inputKeyupEnter="searchEvent"/>
                </div>
              </template>
            </ElLabel>
        </div>
        <div class="col-md-4 mb-3">
          <ElLabel name="일시">
            <template #end="{id}">
              <div class="d-flex justify-content-between" :id="id">
                <DatePicker :select-date="state.searchParams.start_dt" @return="r => state.searchParams.start_dt = r" />
                &nbsp;~&nbsp;
                <DatePicker :select-date="state.searchParams.end_dt" @return="r => state.searchParams.end_dt = r" />
              </div>
            </template>
          </ElLabel>
          
        </div>
      </div>

    </div>
    <div class="search-detail-wrap"></div>
    <div class="text-end py-2">
      <ElButton type="search" @buttonClick="searchEvent()">검색</ElButton>
    </div>
    <div class="d-flex justify-content-between">
      <div></div>
      <div class="table-btn-group">
        <ElButton type="excelDownload" @buttonClick="excelDown()">엑셀다운</ElButton>
      </div>
    </div>

    <div class="table-responsive table-list">
      <DataTable 
        :value="state.gridRowData" 
        selectionMode="single"
        scrollable 
        scrollHeight="500px" 
        removableSort
        paginator 
        :rows="20" 
        :rowsPerPageOptions="[10, 20, 50, 100, 200]" 
        @rowSelect="onRowSelect"
      >
        <template #empty>
          <div>데이터가 존재하지 않습니다.</div>
        </template>
        <Column>
          <template #header>
              <ElCheckbox v-model="allCheck"/>
          </template>
          <template #body="{ data }">
              <ElCheckbox 
              v-model="state.selectedRow" 
              :value="data.ev_seq"
              />
          </template>
        </Column>
        <Column v-for="(event,index) of state.gridColumn" :key="index" :field="event.field" :header="event.headerName" sortable
          :style="event.style">

          <template #body="{ data, field }">
            <div 
              v-if="event.field == 'event_nm'" 
              v-bind:title="data.event_nm" 
              style="width: 150px;;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
              {{ data.event_nm }}
            </div>
            <div 
              v-else-if="event.field == 'prpss'" 
              v-bind:title="data.prpss"
              style="width: 150px;;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
              {{ data.prpss }}
            </div>
            <div 
              v-else-if="event.field == 'sponsor'" 
              v-bind:title="data.sponsor"
              style="width: 150px;;text-overflow:ellipsis; overflow:hidden; white-space:nowrap;"
            >
              {{ data.sponsor }}
            </div>
            <span v-else>{{ data[field] }}</span>
          </template>
        </Column>
      </DataTable>
    </div>

    <div class="text-end py-3">
      <ElButton v-if="!userStore.isExecutive" type="primary" @buttonClick="$router.push('/sm/MSM_SA_007')">신규등록</ElButton>
      <ElButton type="primary" @buttonClick="shareToUser()">공유하기</ElButton>      
    </div>

  </div>


  <!-- @return="data => getExcelData(data)"   -->
  <div>
    <EmailSendModal ref="emailSendModalRef" />
    <ExcelManage ref="excelManageRef" v-show="false">
    </ExcelManage>
  </div>

  <span id="selectedRows"></span>

</template>

<script setup>
import { reactive, ref, onMounted, onBeforeMount, computed } from 'vue'
import DatePicker from '@/components/common/DatePicker.vue';
import ExcelManage from '@/components/common/MCO_EX_001.vue';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import vueRouterCmn from '@/js/vueRouterCmn';
import { useRouter } from "vue-router";
import EmailSendModal from "@/components/common/modal/EmailSendModal.vue";

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { eventList } from '@/api/event';
import common from '@/js/common';
const router = useRouter();
const excelManageRef = ref();
const yearsList = ref([]);
const emailSendModalRef = ref();

import { useUserStore } from '@/store/user';
const userStore = useUserStore()

const canUpdate = computed(()=>{
  return common.checkAccessAuth('M002M003M001')
})
const getYearsList = () => {
  const prevYear = new Date().getFullYear() - 6;   // 2018
  const currYear = new Date().getFullYear();     // 2024 

  for (let i = currYear; i >= prevYear; i--) {
    yearsList.value = [...yearsList.value, i];  ///yearsList.value.push(i); 배열표현법이 신기하다

  }

  state.searchParams.fs_year = yearsList.value[0];

}

// 기간설정 초기화 중 DatePicker에서 한달 후 값으로 입력받아 넣으니 달을 바꿔도 무조건 
// 그 다음달로 초기화 되어 end_dt에 대해서만 적용해 주기 위해 아래 값으로 대체함.
var dt = new Date();
var startStr = dt.getFullYear() + '-' + (dt.getMonth() + 1) + '-' + dt.getDate();
var endStr = dt.getFullYear() + '-' + (dt.getMonth() + 2) + '-' + dt.getDate();

onMounted(() => {
  getYearsList();
})

onBeforeMount(async () => {
  state.searchParams.start_dt = startStr;
  state.searchParams.end_dt = endStr;
  getDataList();
})

const state = reactive({
  //컬럼 셋팅
  gridColumn: [
    //width 로 각 셀 크기 조절 가능
    // { headerName: 'NO' ,       field: "ev_seq", style: {minWidth: '50px'}, checkboxSelection: false},
    { headerName: '이벤트 이름', field: "event_nm", style: { minWidth: '150px' } },
    { headerName: '일시', field: "fmt_event_dt", style: { textAlign : 'center',minWidth: '100px' } },
    { headerName: '장소', field: "event_place", style: { minWidth: '100px' } },
    { headerName: '주관사', field: "sponsor", style: { minWidth: '150px' } },
    { headerName: '목적', field: "prpss", style: { minWidth: '150px' } },
    { headerName: '발표자', field: "prsnt", style: { textAlign : 'center',minWidth: '100px' } },
    { headerName: '등록자', field: "reg_user_nm", style: { textAlign : 'center',minWidth: '100px' } },
    { headerName: '수정자', field: "upd_user_nm", style: { textAlign : 'center',minWidth: '100px' } },
  ],
  //백에서 받아와서 보여줄 list 데이터
  gridRowData: [],
  selectedRow: [],
  searchParams: {
    fs_year: '',       // 회계년도   
    event_nm: '',      // 이벤트명
    prpss: '',         // 목적
    start_dt: '',
    end_dt: '',
    page_count: 1,
    unit_count: 100000,
  },
   format:'yyyy',
   excelColumn: [
    { headerName: '이벤트 이름', field: "event_nm", style: { minWidth: '150px' } },
    { headerName: '일시', field: "fmt_event_dt", style: { textAlign : 'center',minWidth: '100px' } },
    { headerName: '장소', field: "event_place", style: { minWidth: '100px' } },
     { headerName: '목적', field: "prpss", style: { minWidth: '150px' } },
    { headerName: '주관사', field: "sponsor", style: { minWidth: '150px' } },
    { headerName: '발표자', field: "prsnt", style: { minWidth: '100px' } },
    { headerName: '행사장 규모', field: "event_scale", style: { minWidth: '100px' } },
    { headerName: '행사 증정품', field: "gift", style: { minWidth: '100px' } },
    { headerName: '행사내용', field: "event_dtls", style: { minWidth: '100px' } },
    { headerName: '클레임비용', field: "claim_cost", style: { minWidth: '100px' } },
    { headerName: '마케팅 펀딩사', field: "mk_fund", style: { minWidth: '100px' } },
    { headerName: '클레임 처리방법', field: "claim_mthd", style: { minWidth: '100px' } },
    { headerName: '발표자', field: "prsnt", style: { minWidth: '100px' } },
    { headerName: '등록자', field: "reg_user_nm", style: { textAlign : 'center',minWidth: '100px' } },
    { headerName: '수정자', field: "upd_user_nm", style: { textAlign : 'center',minWidth: '100px' } },
  ],
})

const allCheck = computed({
  get() {
    return state.gridRowData.length === state.selectedRow.length;
  },
  set(newValue) {
    state.selectedRow = newValue ? state.gridRowData.map((item) => { return item.ev_seq }) : [];
  }
})


const getDataList = async () => {
  try {
    setIsLoading(true)
    const res = await eventList(state.searchParams)
    state.gridRowData = res.rtn;
  } catch (err) {
    console.error(err)
    alert("조회 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
};


const searchEvent = () => {
  /* 
     회계년도 및 기간관련 Validation Check
  */

  if (state.searchParams.start_dt > state.searchParams.end_dt) {
    alert('기간 설정을 확인하세요!')
    return false
  }

  if (state.searchParams.start_dt) {
    if ((state.searchParams.fs_year != state.searchParams.start_dt.substring(0, 4))) {
      alert('회계년도와 일시 조건이 서로 일치하지 않습니다.')
      return false
    }
  }

  if (state.searchParams.end_dt) {
    if ((state.searchParams.fs_year != state.searchParams.end_dt.substring(0, 4))) {
      alert('회계년도와 일시 조건이 서로 일치하지 않습니다.')
      return false
    }
  }


  getDataList();
}

const onRowSelect = (event) => {
  if(canUpdate.value){
    vueRouterCmn.routerPush('MSM_SA_009', { ev_seq: event.data.ev_seq })
  }else{
    vueRouterCmn.routerPush('MSM_SA_012', { ev_seq: event.data.ev_seq })
  }
}


//엑셀 다운로드
const excelDown = async () => {
  let fileNm = '이벤트 리스트'
  let header = state.excelColumn
  let dataList = state.gridRowData
  if (state.selectedRow?.length > 0) {
    let checkList = state.gridRowData.filter((item) => {
      for (let i of state.selectedRow) {
        if (i == item.ev_seq) {
          return item
        }
      }
    })
    dataList = checkList
  }

  excelManageRef.value.excelDownload(fileNm, header, dataList)
}

//공유하기
const shareToUser = () => {
  openEmailSend();
}

/** 메일발송 모달 (3.팝업오픈) */
const openEmailSend = () => {
  //메일정보 초기값
  const emailParams = {
    call_prgm_id: 'MCP_CR_002',
    call_prgm_nm: '회사 조회/수정',
    receiver_ids: '',
    receiver_nms: '',
    title: '이벤트 정보 공유드립니다.',
    content: makeEmailContent()
  };

  emailSendModalRef.value.openEmailModal(emailParams);
};

/** 메일발송 모달 (4.메일내용) */
const makeEmailContent = () => {
  //선택된 회사의 목록
  let selectEvents = [];
  if (state.selectedRow?.length > 0) {
    selectEvents = state.gridRowData.filter((item) => {
      for (let i of state.selectedRow) {
        if (i == item.ev_seq) {
          return item;
        }
      }
    });
  }

  //메일 내용 만들기
  let content = '';
  for (let event of selectEvents) {
    content += `<b>이벤트 이름: ${event.event_nm}</b> 일시: ${event.fmt_event_dt}, 장소: ${event.event_place}, 주관사: ${event.sponsor},목적: ${event.prpss},발표자: ${event.prsnt}<br/>`;
  } 
  return content;
}

</script>
